import { render, staticRenderFns } from "./SplitItemsByAddress.vue?vue&type=template&id=1c265c2e&scoped=true"
import script from "./SplitItemsByAddress.vue?vue&type=script&lang=js"
export * from "./SplitItemsByAddress.vue?vue&type=script&lang=js"
import style0 from "./SplitItemsByAddress.vue?vue&type=style&index=0&id=1c265c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c265c2e",
  null
  
)

export default component.exports